import React from 'react';
import { twMerge } from 'tailwind-merge';
type Tone = 'neutral' | 'brand' | 'accent' | 'overlay' | 'success';
interface TagProps {
  children: React.ReactNode;
  tone?: Tone;
  icon?: React.ReactNode;
  className?: string;
}
const toneClass: Record<Tone, string> = {
  neutral: 'bg-surface-2 text-ink-2',
  brand: 'bg-tint text-brand-strong',
  accent: 'bg-accent text-on-accent',
  overlay: 'bg-black/55 text-white backdrop-blur-md',
  success: 'bg-ink text-bg'
};
export function Tag({
  children,
  tone = 'neutral',
  icon,
  className
}: TagProps) {
  return <span className={twMerge('inline-flex h-7 items-center gap-1 whitespace-nowrap rounded-full px-2.5 text-[13px] font-bold', toneClass[tone], className)} data-id="element-844" data-mp="3ozizfqnu2t0e">
      {icon}
      {children}
    </span>;
}